var __s__ = require('./support-fns.js');
var Preloader = require('./preloader.js');
var Jaw3DConstants = require('./jaw3d-constants.js');
var Jaw3DRenderer = require('./jaw3d-renderer.js');
var Jaw3DJaw = require('./jaw3d-jaw.js');
var Jaw3DTooth= require('./jaw3d-tooth.js');
// var THREE = require('three');

//Class Scene
export class Scene {

    constructor (node, upperJawVisible = true, lowerJawVisible = true, opts = null,
                 callbackMouseover = null, callbackClick = null) {

        let me = this;
        const version = 0.21;

        var baseUrl = window.origin;

        this.options = __s__.extend({
                loaderColor: "#B4EAE6",
                loaderColorSucess: "#4FBCB1",
                initialCameraPosition: {x:0, y:0, z: 13.1},
                dampingFactor: 0.2,
                colors: { mr1: 0xc64f41, mr2: 0x8d3029, teeth: 0xd4d2b9,
                        background: 0xe7edee,
                        connectorSphere: 0x578de7, connection: 0x000000},
                labelScale: 1,
                connectionLineWidth: 2,
                REPOSITION_Y: 0,
                baseUrl: baseUrl,
                extraModelsJson: baseUrl + '/3dobjects/extras/index.js',
                screenshots : { width: 600, height: 600, format: "png", transparent: true }
            }, opts);

        this.modelFiles = { obj: "teeth.obj", mtl: "teeth.mtl", dir: baseUrl + '/3dobjects/'};

        let ic = this.options.initialCameraPosition;
        this._cameraPosition = new THREE.Vector3(ic.x, ic.y, ic.z);

        this.width = 0;
        this.height = 0;

        this._angle = 0;
        this._freeMove = true;
        this._numberFormat = Jaw3DConstants.NumberFormat.UNS;

        this._focusedJaw = Jaw3DConstants.FocusJaw.GLOBAL;
        this.__effectiveCentroid = new THREE.Vector3(0, this.options.REPOSITION_Y, 0);

        this._gumsVisibility = Jaw3DConstants.VisibilityType.SOLID;
        this._labelsVisibility = Jaw3DConstants.VisibilityType.NONE;
        this._connectorsVisibility = Jaw3DConstants.VisibilityType.SOLID;

        var nodeId = "app3d-container-" + Math.round(Math.random() * 100000);
        this._nodeId = nodeId;
        this._nodeFrame = node;

        this._node = (function createDomElements() {
            let divMainC, divRenderC, divLloadingC, divLoadingText;

            //Main DOM element
            divMainC = document.createElement("div");
            divMainC.className = "app3d-container";
            divMainC.id = nodeId;
            // console.log(divMainC);

            //Renderer container
            divRenderC = document.createElement("div");
            divRenderC.className = "app3d-render-container";
            divRenderC.id = divMainC.id + "-render";
            divMainC.appendChild(divRenderC);
            divMainC.divRenderC = divRenderC;

            //Loading div
            divLloadingC = document.createElement("div");
            divLloadingC.className = "app3d-loading-div";
            divLloadingC.id = divMainC.id + "-loading-div";
            divMainC.appendChild(divLloadingC);

            //Loading text inside loading div
            divLoadingText = document.createElement("div");
            divLoadingText.className = "app3d-loading-div-text";
            divLoadingText.id = divMainC.id + "-loading-text";
            divLloadingC.appendChild(divLoadingText);

            //initialize loader functions
            divMainC.loadingDiv = new Preloader.Preloader(divLloadingC, divLoadingText, 70, me.options, "img-loader-logo");

            //Append to DOM element
            node.appendChild(divMainC);

            return divMainC;
        }());

        this.upperJaw = new Jaw3DJaw.Jaw(1, this);
        this.lowerJaw = new Jaw3DJaw.Jaw(0, this);
        this.upperJaw.visible = upperJawVisible;
        this.lowerJaw.visible = lowerJawVisible;

        this._allTeeth3D = [];
        this._allConnectors = new Map();

        this._callbackMouseover = callbackMouseover;
        this._callbackClick = callbackClick;

        this.renderer3d = null;
        this.init();

    }//constructor

    isVisible() {
        return document.getElementById(this._nodeId) != null;
    }

    reset() {
      this.upperJaw.reset();
      this.lowerJaw.reset();
    }

    init() {
        let that = this;

        this.updateSize();
        this.renderer3d = new Jaw3DRenderer.Renderer3D(this, this.width, this.height);

        __s__.addEventLnr(window, "resize", function() {
            that.updateSize();
            that.focusScene();
        } );

        this.renderer3d.init();
        this.renderer3d.loadStart(this);

        this.updateLabelsVisibility();
    }

    get angle() { return this._angle; }

    get freeMove() { return this._freeMove; }
    set freeMove(v) {
         this._freeMove = !!v;
         if (this.renderer3d === null) { return; }
         this.renderer3d.controls.enabled = this._freeMove;
    }

    get cameraPosition() { return this.renderer3d.camera.position.clone(); }
    get focusedJaw() { return this._focusedJaw; }
    set focusedJaw(v) {
        if (v !== Jaw3DConstants.FocusJaw.GLOBAL && v !== Jaw3DConstants.FocusJaw.UPPER && v !== Jaw3DConstants.FocusJaw.LOWER) { return; }
        this._focusedJaw = v;
    }

    get numberFormat() { return this._numberFormat; }
    set numberFormat(v) {
        if (this._numberFormat === v || (v !== Jaw3DConstants.NumberFormat.UNS && v !== Jaw3DConstants.NumberFormat.FDI)) { return; }

        this._numberFormat = v;
        this.updateLabelsVisibility();

    }

    get labelsVisibility() { return this._labelsVisibility; }
    set labelsVisibility(v) {
        if (this._labelsVisibility === v || (v !== Jaw3DConstants.VisibilityType.SOLID && v !== Jaw3DConstants.VisibilityType.NONE)) { return; }

        this._labelsVisibility = v;
        this.updateLabelsVisibility();
    }

    get gumsVisibility() { return this._gumsVisibility; }
    set gumsVisibility(v) {
        let mr1, mr2, isWireframe;

        if (this._gumsVisibility === v || (v !== Jaw3DConstants.VisibilityType.SOLID && v !== Jaw3DConstants.VisibilityType.WIREFRAME && v !== Jaw3DConstants.VisibilityType.NONE)) { return; }

        this._gumsVisibility = v;

        if (v === Jaw3DConstants.VisibilityType.NONE) {
            this.lowerJaw.mr1.visible = false;
            this.lowerJaw.mr2.visible = false;
            this.upperJaw.mr1.visible = false;
            this.upperJaw.mr2.visible = false;
            return;
        }

        isWireframe = v === Jaw3DConstants.VisibilityType.WIREFRAME;
        mr1 = new THREE.MeshPhongMaterial({ color: this.options.colors.mr1, wireframe: isWireframe, side: THREE.DoubleSide });
        mr2 = new THREE.MeshPhongMaterial({ color: this.options.colors.mr2, wireframe: isWireframe, side: THREE.DoubleSide });

        this.lowerJaw.mr1.visible = true;
        this.lowerJaw.mr2.visible = true;
        this.upperJaw.mr1.visible = true;
        this.upperJaw.mr2.visible = true;
        this.lowerJaw.mr1.material = mr1;
        this.lowerJaw.mr2.material = mr2;
        this.upperJaw.mr1.material = mr1;
        this.upperJaw.mr2.material = mr2;
    }

    get connectorsVisibility() { return this._connectorsVisibility }
    set connectorsVisibility(v) {
        if (this._connectorsVisibility === v
            || (
                v !== Jaw3DConstants.VisibilityType.SOLID
                && v !== Jaw3DConstants.VisibilityType.NONE
                && v !== Jaw3DConstants.VisibilityType.INSIDE
                && v !== Jaw3DConstants.VisibilityType.OUTSIDE
            )) {
            return;
        }

        this._connectorsVisibility = v;

        let vIns = true, vOut = true;

        switch (v) {
            case Jaw3DConstants.VisibilityType.NONE:
                vIns = false;
                vOut = false;
                break;
            case Jaw3DConstants.VisibilityType.OUTSIDE:
                vIns = false;
                break;
            case Jaw3DConstants.VisibilityType.INSIDE:
                vOut = false;
                break;
        }

        for (let value of this._allConnectors.values()) {
            value.toggleVisibility(vIns, vOut);
        }
    }

    getElement() {
        return this._node;
    }

    getDimensions() {
        return { width: this.width, height: this.height };
    }

    setDimensions(w, h) {
        this.width = w;
        this.height = h;
    }

    updateSize() {
        let  divMainC, par, ev,
            dim, w, h;

        divMainC = this.getElement();
        par = divMainC.parentNode;

        if (par === null || par === undefined) { return; }

        dim = this.getDimensions();
        w = par.offsetWidth;
        h = par.offsetHeight;

        if (dim.width !== w || dim.height !== h) {
            divMainC.style.width = w + "px";
            divMainC.style.height = h + "px";
            if (this.renderer3d) { this.renderer3d.resize3DViewer(w, h); }
            this.setDimensions(w, h);

            ev = __s__.addEventDsptchr("resize");
            this._node.dispatchEvent(ev);
        }
    }

    _addTooth(name, uns, fdi, upper, crown, info, mesh, material) {
        let jaw = upper ? this.upperJaw : this.lowerJaw,
            tooth;

        if (!jaw.teeth[name]) {
            tooth = new Jaw3DTooth.Tooth(name, uns, fdi, upper, jaw, material);
            jaw._attachTooth(tooth);
            this._allTeeth3D.push(tooth);
        } else {
            tooth = jaw.teeth[name];
        }
        tooth._addPartMesh(mesh, crown);
        if (crown) { tooth.obj3DInfo = info; }
    }

    updateLabelsVisibility() {
        let vs = {},
            allInvisible = [false, false, false, false],
            finalVs;

        vs[Jaw3DConstants.NumberFormat.UNS] = [false, false, false, false];
        vs[Jaw3DConstants.NumberFormat.FDI] = [false, false, false, false];
        vs[Jaw3DConstants.NumberFormat.UNS][0] = true;
        vs[Jaw3DConstants.NumberFormat.UNS][2] = true;
        vs[Jaw3DConstants.NumberFormat.FDI][1] = true;
        vs[Jaw3DConstants.NumberFormat.FDI][3] = true;

        if (this._labelsVisibility === Jaw3DConstants.VisibilityType.NONE) {
            finalVs = allInvisible;
        } else {
            finalVs = vs[this._numberFormat];
        }

        this.upperJaw.group3D.labelsUns.visible = finalVs[0];
        this.upperJaw.group3D.labelsFdi.visible = finalVs[1];
        this.lowerJaw.group3D.labelsUns.visible = finalVs[2];
        this.lowerJaw.group3D.labelsFdi.visible = finalVs[3];
    }

    setCameraPosition(x, y, z, timing = 0.75) {
        let me = this,
            ev = __s__.addEventDsptchr("cameraChanged"),
            prom,
            camPos = this.renderer3d.camera.position;

        if (this.renderer3d === null) { return; }

        timing = Math.min(5, Math.max(0.01, timing));

        prom = new Promise(function(resolve, reject){

            TweenLite.to(camPos, timing, {
                x: x,
                y: y,
                z: z,
                ease: Power2.easeInOut,
                onCompleteScope: me,
                onComplete: function() {
                    ev.data = { cameraPosition: me.renderer3d.camera.position };
                    me._node.dispatchEvent(ev);
                    resolve();
                }
            });

        });

        return prom;
    }

    //This function makes the model to fit in the window -front face-
    focusScene(selected = this._focusedJaw, timing = 0.75, frontalView = false) {

        let me = this,
            modelY, modelX, modelZ, modelDimMax, dist,
            camCurrDist, scalarCorrection, camNewPos,
            ev = __s__.addEventDsptchr("changeCameraPosition"),
            bbox, bboxPos,
            camPos = this.renderer3d.camera.position,
            ctrlTar = this.renderer3d.controls.target,
            prom;

        timing = Math.min(5, Math.max(0.01, timing));

        if (this.renderer3d === null) { return; }

        prom = new Promise(function(resolve, reject){

            //Get dimensions of model -change with the jaws' angle and jaw/global focus-
            bbox = me.renderer3d.bbox; //Global
            if (selected === Jaw3DConstants.FocusJaw.UPPER) { bbox = me.upperJaw.group3D.bbox; }
            if (selected === Jaw3DConstants.FocusJaw.LOWER) { bbox = me.lowerJaw.group3D.bbox; }
            me._focusedJaw = selected;

            bbox.update();
            bboxPos = bbox.position.clone();
            me.__effectiveCentroid = bboxPos;

            modelY = Math.abs(bbox.box.max.y - bbox.box.min.y);
            modelX = Math.abs(bbox.box.max.x - bbox.box.min.x);
            modelZ = Math.abs(bbox.box.max.z - bbox.box.min.z);
            modelDimMax = Math.max(modelX, modelY, modelZ) + (2 * (me._angle/180));
            //Calc distance of camera to 0
            dist = (modelDimMax / 2) / Math.tan((me.renderer3d.camera.fov * Math.PI / 180) / 2);
            //Add the depth of the model (front)
            dist += bbox.box.max.z;

            //Calculate z given x & y
            if (frontalView) { camPos = new THREE.Vector3(0, bboxPos.y, 16); }
            camCurrDist = camPos.clone()
                .distanceTo(new THREE.Vector3(0,0,0));

            scalarCorrection = dist / camCurrDist;
            camNewPos = camPos.clone().multiplyScalar(scalarCorrection);

            TweenLite.to(me.renderer3d.camera.position, timing, {
                        x: camNewPos.x,
                        y: camNewPos.y,
                        z: camNewPos.z,
                        ease: Power2.easeInOut
                    });

            TweenLite.to(ctrlTar, timing, {
                        x: bboxPos.x,
                        y: bboxPos.y,
                        z: bboxPos.z,
                        ease: Power2.easeInOut,
                        onComplete: function() {
                            //Dispatch event
                            me._node.dispatchEvent(ev);
                            resolve();
                        }
                    });
        });

        return prom;

    }

    calculateMathBoundingBox(selected = this._focusedJaw) {
        let angleHalf = me._angle / 2,
            dimsU = me.upperJaw.group3D.myInfo,
            dimsL = me.lowerJaw.group3D.myInfo,
            //ax is the Adjacent, bx is the Opposite
            a1 = Math.cos(angleHalf / 180 * Math.PI) * dimsU.myDimensions.z,
            b1 = Math.sin(angleHalf / 180 * Math.PI) * dimsU.myDimensions.z,
            a2 = Math.cos((90 - angleHalf) / 180 * Math.PI) * dimsU.myDimensions.y,
            b2 = Math.sin((90 - angleHalf) / 180 * Math.PI) * dimsU.myDimensions.y,
            c1 = Math.cos(angleHalf / 180 * Math.PI) * dimsL.myDimensions.z,
            d1 = Math.sin(angleHalf / 180 * Math.PI) * dimsL.myDimensions.z,
            c2 = Math.cos((90 - angleHalf) / 180 * Math.PI) * dimsL.myDimensions.y,
            d2 = Math.sin((90 - angleHalf) / 180 * Math.PI) * dimsL.myDimensions.y,
            a = a1 + a2,
            b = b1 + b2,
            c = c1 + c2,
            d = d1 + d2,
            yy = b + d,
            xx = Math.max(dimsU.myDimensions.x, dimsL.myDimensions.x),
            zz = Math.max(a, c);

            if (selected === Jaw3DConstants.FocusJaw.UPPER) {
                return { dims: { x: dimsU.myDimensions.x, y: b, z: a }, centroid: dimsU.centroid };
            } else if (selected === Jaw3DConstants.FocusJaw.LOWER) {
                return { dims: { x: dimsL.myDimensions.x, y: d, z: c }, centroid: dimsL.centroid };
            } else {
                return { dims: { x: xx, y: yy, z: zz }, centroid: {x: 0, y: 0, z: 0} };
            }
    }

    /// angle: The angle should be in degrees 0-180
    /// animate: time in seconds for animation (0 for none)
    setAngle(angle, animate = 0, frontalView = false) {

        let me = this,
            prom,
            tween = { val: me._angle / 360 * Math.PI }; //half for each jaw, 360 instead of 180

        angle = Math.max(0, Math.min(180, angle));
        const angleHalf = angle / 360 * Math.PI;

        function doRotation() {
            me.upperJaw.group3D.rotation.x = -tween.val;
            me.lowerJaw.group3D.rotation.x = tween.val;
        }

        prom = new Promise(function(resolve, reject){
            let sameAng = Math.abs(angle - me._angle) < 0.1;

            if (animate === 0) {
                let ev = __s__.addEventDsptchr("changeAngle");
                ev.data = { angle: angle };

                tween = { val: angleHalf };
                doRotation();

                me._node.dispatchEvent(ev);
                me._angle = angle;
                me.focusScene(this._focusedJaw, 0.01);
                resolve();
            } else {
                TweenLite.to(tween,
                    sameAng ? 0.1 : animate,
                    {
                        val: angleHalf,
                        ease: Power2.easeInOut,
                        onUpdate: doRotation,
                        onCompleteScope: me,
                        onComplete: function() {
                            let ev = __s__.addEventDsptchr("changeAngle");
                            ev.data = { angle: angle };
                            me._node.dispatchEvent(ev);
                            me._angle = angle;
                            me.upperJaw.group3D.bbox.update();
                            me.lowerJaw.group3D.bbox.update();
                            me.focusScene(this._focusedJaw, animate, frontalView);
                            resolve();
                    }
                });
            }
        });

        return prom;
    }

    getTooth(num, nf = this._numberFormat) {
        let tooth = null,
            numStr = String(num);

        if (nf === Jaw3DConstants.NumberFormat.FDI) {
            tooth = this.upperJaw.teethByFDI[numStr];
            if (!tooth) { tooth = this.lowerJaw.teethByFDI[numStr]; }
        } else {
            tooth = this.upperJaw.teethByUNS[numStr];
            if (!tooth) { tooth = this.lowerJaw.teethByUNS[numStr]; }
        }
        return tooth;
    }

    getConnector(tooth, conectableTooth) {
        let t1 = typeof tooth === "string" ? this.getTooth(tooth) : tooth,
            t2 = typeof conectableTooth === "string" ? this.getTooth(conectableTooth) : conectableTooth,
            cname = __s__.connerctorName(t1.numberUNS, t2.numberUNS);

        return this._allConnectors.get(cname);
    }

    getConnectorByName(cname) {
        return this._allConnectors.get(cname);
    }

    //Shortcuts
    open(animate = 0) {
        this.focusedJaw = Jaw3DConstants.FocusJaw.GLOBAL;
        this.setAngle(180, animate, true);
    }

    close(animate = 0) {
        this.focusedJaw = Jaw3DConstants.FocusJaw.GLOBAL;
        this.setAngle(0, animate, true);
    }

    focusUpper(animate = 0) {
        this.focusedJaw = Jaw3DConstants.FocusJaw.UPPER;
        this.setAngle(180, animate, true);
    }

    focusLower(animate = 0) {
        this.focusedJaw = Jaw3DConstants.FocusJaw.LOWER;
        this.setAngle(180, animate, true);
    }

    disableFreeMove() {
        this.freeMove = false;
        this.close(1);
    }

    //Generate screenshots
    //Returns an image/data format
    generateScreenshot(
        width = this.options.screenshots.width,
        height = this.options.screenshots.height,
        format = this.options.screenshots.format,
        transparent = this.options.screenshots.transparent) {

        let me = this,
            data,
            renderer,
            prevSize,
            delay = 500,
            origCamPos,
            imageFormat = "image/png",
            loadDiv = this._node.loadingDiv;

        //Too early
        if (!this.renderer3d) { console.warn("Not ready to take screenshots."); return null; }

        this.renderer3d._isTakingScreenshot = true;
        renderer = this.renderer3d.renderer;
        origCamPos = this.renderer3d.camera.position.clone();

        //Default format is PNG
        format = format.toLowerCase();
        if (format === "jpg" || format === "jpeg") { imageFormat = "image/jpeg"; }

        //Put the loading Div
        loadDiv.setMessage("Generating screenshot");
        loadDiv.setPercentage(0);
        loadDiv.show();
        loadDiv.updateLoader(1, delay / 1000);

        //Adjust size & background
        renderer.setSize(width, height);
        this.renderer3d.camera.aspect = width / height;
        this.renderer3d.camera.updateProjectionMatrix();

        if (transparent) { renderer.setClearColor(this.options.colors.background, 0); }

        //Take it
        renderer.render(this.renderer3d.scene, this.renderer3d.camera);
        data = renderer.domElement.toDataURL(imageFormat);

        //Revert size & background
        renderer.setSize(this.width, this.height);
        if (transparent) { renderer.setClearColor(this.options.colors.background, 1); }
        this.renderer3d.camera.aspect = this.width / this.height;
        this.renderer3d.camera.updateProjectionMatrix();

        setTimeout(function(){
            loadDiv.hide();
            me.renderer3d._isTakingScreenshot = false;
        }, delay);

        return data;
    }

}
